module.exports = __webpack_public_path__ + "static/scale-model-of-audubon-acres-in-chattanooga-tennessee-0e33ad09e8accffccafb8bd06870ec6a.png";